// styles
import { themeOptions } from 'styles';

// libraries
import styled from 'styled-components';

export const StyledBasicPasswordV2 = styled.div`
  position: relative;

  span {
    font-weight: 600;
    display: inline-block;
    margin-bottom: 7px;
    padding-left: 8px;
    display: flex;
    align-items: center;
    position: relative;

    .required {
      color: red;
      padding-left: 0;

      span {
        width: 10px;
        height: 5px;
        position: relative;
        top: -4px;
        left: 2px;
      }
    }
  }

  .MuiOutlinedInput-root {
    height: 40px;
    width: 100%;
    overflow: hidden;
    background-color: ${themeOptions.palette.white.main};
    border: 1px solid ${themeOptions.palette.gray.border};
    border-radius: 6px;

    &:hover {
      box-shadow: 0px 0px 0px 3px var(--color-off-white);
      .MuiOutlinedInput-notchedOutline {
        border: 1px solid #dadada;
      }
    }
    &:active {
      border-color: ${themeOptions.palette.green.main};
    }

    .MuiOutlinedInput-input {
      padding: 0 10px;
      width: 100%;
      border-radius: 6px;
      outline: none;
      appearance: none;
      background-color: ${themeOptions.palette.white.main};

      &:disabled {
        background-color: ${themeOptions.palette.gray.light};
      }
    }
  }

  /* required 경우, disabled style */
  .MuiOutlinedInput-root.Mui-disabled {
    background-color: ${themeOptions.palette.gray.light};
  }
`;
